module.exports = __webpack_public_path__ + "static/media/yopen-login.6aff0e70.svg";